import React from "react";
import { TableProps } from '../iTable';
import { TableInterface } from "../index";
export default function bigDataXS(Table: React.ComponentClass<Partial<TableProps>> | TableInterface) {
    const BigDataX: React.FC<TableProps> = React.forwardRef((props, ref) => {
        return <Table
            {...props}
            isBigData={true}
            // @ts-ignore
            ref={ref}
        ></Table>
    });

    return BigDataX as React.ComponentClass<Partial<TableProps>> | TableInterface;
}